module.exports = __webpack_public_path__ + "static/media/topic01.af95aef6.jpg";